<template>
    <div
        :class="[(getStyle !== '' ? `MobileSubProductList--${getStyle}` : '')]"
        class="MobileSubProductList"
    >
        <component
            v-if="level > 1"
            :is="getTitleTag"
            :class="'MobileSubProductList-title--' + getTitleTag"
            class="MobileSubProductList-title"
        >
            {{ name }}
        </component>
        <ul
            v-if="products.length > 0"
            class="MobileSubProductList-list"
        >
            <li class="MobileSubProductList-listItem">
                <mobile-product-item
                    v-for="(product, productIndex) in products"
                    :key="product.id"
                    :index="productIndex"
                    :product="product"
                    :sectionStyle="getStyle"
                    :level="level+1"
                    :link-to-product-page="linkToProductPage"
                    class="MobileSubProductList-product"
                />
            </li>
        </ul>
        <mobile-sub-product-list
            v-for="(section) in getSections"
            v-bind="section"
            :key="section.id"
            class="MobileSubProductList-subProductList"
        />
    </div>
</template>

<script setup>
import { useProductList } from '@/StoreWeb/js/composables/useProductList'
import MobileProductItem from './MobileProductItem'

const props = defineProps({
    level: {
        type: Number,
        default: 1
    },
    name: {
        type: String,
        required: true
    },
    products: {
        type: Array,
        required: true
    },
    sections: {
        type: Array,
        default: null
    },
    sectionStyle: {
        type: String,
        default: ''
    },
    linkToProductPage: {
        type: Boolean,
        default: true
    }
})

const { getSections, getStyle, getTitleTag } = useProductList(props)
</script>

<style lang="scss" scoped>
@import 'globalScss';

.MobileSubProductList {
    &-list {
        margin: 0 0 $s10;
        padding: 0;
        list-style: none;
    }

    &-listItem {
        margin: 0;
        padding: 0;
    }

    &-title {
        @extend %h2;

        position: relative;
        margin: $s5 0 $s2;

        @media #{map-get($display-breakpoints, 'sm-and-up')} {
            font-size: 32px;
        }

        &--h3 {
            @extend %h3;

            @media #{map-get($display-breakpoints, 'sm-and-up')} {
                font-size: 24px;
            }
        }

        &--h4 {
            @extend %h4;

            @media #{map-get($display-breakpoints, 'sm-and-up')} {
                font-size: 18px;
            }
        }

        &::after {
            content: '';
            position: absolute;
            bottom: -10px;
            left: 0;
            width: 30px;
            height: 4px;
            background: $color-brandPrimary;
        }
    }
}
</style>
